/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
const t=t=>"field"===t.type,e=t=>"group"===t.type,n=t=>"text"===t.type,r=t=>"relationship"===t.type;function p(t){return o(t)||u(t)}function o(t){return"text-area"===t.type}function u(t){return"text-box"===t.type}export{t as isFieldElement,e as isGroupElement,r as isRelationshipElement,o as isTextAreaInput,u as isTextBoxInput,n as isTextElement,p as isTextInput};
